import { ChartMark, WidgetKind, type Report } from 'corso-admin-ui';
import {
  finalizedTrend,
  operationsWidgets,
  readyForReview,
  refundOwedSoon,
} from '../claimItems';

const byDeliveredDay = 'By the day the return was delivered';

export const operations = {
  key: 'operations',
  label: 'Operations',
  dataset: 'claimItems',
  timeFields: ['createdOn'],
  widgets: [
    { ...refundOwedSoon, title: 'Potential refund amount owed soon' },
    ...operationsWidgets([
      finalizedTrend(
        'Time from claim to return dropoff',
        'avgDaysClaimToTransit',
      ),
      finalizedTrend(
        'Time from return dropoff to delivered',
        'avgDaysInTransit',
      ),
      finalizedTrend(
        'Time from delivered to resolved',
        'avgDaysDeliveredToResolved',
      ),
      finalizedTrend('Time from claim to resolved', 'avgDaysClaimToResolved'),
    ]),
    {
      kind: WidgetKind.overTime,
      title: 'Returns with a label scanned',
      description: 'Return requests, by the day their label was scanned',
      mark: ChartMark.line,
      metrics: ['claims'],
      timeField: 'inTransitOn',
    },
    {
      kind: WidgetKind.overTime,
      title: 'Items delivered and ready for review',
      description: byDeliveredDay,
      mark: ChartMark.bar,
      metrics: ['items'],
      filters: readyForReview,
      timeField: 'deliveredOn',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Ready for review by requested resolution',
      description: byDeliveredDay,
      dimension: 'requestedResolution',
      metric: 'items',
      filters: readyForReview,
      timeField: 'deliveredOn',
    },
    {
      kind: WidgetKind.table,
      title: 'Altered resolutions',
      description:
        'Items resolved another way than requested, by the day the request was finalized',
      dimensions: ['requestedResolution', 'resolution'],
      metrics: ['items'],
      filters: { wasResolutionChanged: true },
      timeField: 'finalizedOn',
    },
  ],
} as const satisfies Report;
